export const GET_INTERCHANGE_TRANSFERS = {
  GET_INTERCHANGE_TRANSFERS_REQUEST: "GET_INTERCHANGE_TRANSFERS_REQUEST",
  GET_INTERCHANGE_TRANSFERS_SUCCESS: "GET_INTERCHANGE_TRANSFERS_SUCCESS",
  GET_INTERCHANGE_TRANSFERS_FAILED: "GET_INTERCHANGE_TRANSFERS_FAILED",
};
